export enum CloseIconType {
    None = 0,
    Left = 1,
    Right = 2,
    CustomLeft = 3,
    CustomRight = 4
}